import React, { useEffect, useState } from "react";

const LOGO_MAX_HEIGHT = "3.5rem";
const LOGO_MAX_HEIGHT_COMPACT = "2.5rem";
const LOGO_MAX_WIDTH_DEFAULT = "4.5rem";
const LOGO_MAX_WIDTH_DEFAULT_COMPACT = "3rem";
const LOGO_MAX_WIDTH_WIDE = "9rem";
const LOGO_MAX_WIDTH_WIDE_COMPACT = "5.5rem";
const STATUS_DOT_SIZE = "0.8rem";
const STATUS_DOT_SIZE_COMPACT = "0.65rem";
const STATUS_DOT_BORDER_WIDTH = "2px";
const STATUS_DOT_BORDER_WIDTH_COMPACT = "1.5px";
const STATUS_DOT_DEFAULT_COLOR = "#34d399";
const STATUS_DOT_OFFSET = "38%";
const STATUS_DOT_OFFSET_COMPACT = "22%";

const LogoImage = ({
  src,
  showStatusDot = false,
  statusColor = STATUS_DOT_DEFAULT_COLOR,
  size = "default",
}) => {
  const [aspect, setAspect] = useState("square");
  const isCompact = size === "compact";

  useEffect(() => {
    if (typeof window === "undefined" || !src) {
      return;
    }

    const img = new Image();
    img.src = src;
    img.onload = () => {
      if (img.width > img.height) {
        setAspect("wide");
      } else if (img.height > img.width) {
        setAspect("tall");
      } else {
        setAspect("square");
      }
    };
  }, [src]);

  const containerStyle = {
    position: "relative",
    display: "inline-flex",
  };

  const imageStyle = {
    display: "block",
    objectFit: "cover",
    height: "100%",
    width: "100%",
    // borderRadius:'50%',
    maxHeight: isCompact ? LOGO_MAX_HEIGHT_COMPACT : LOGO_MAX_HEIGHT,
    maxWidth: isCompact ? LOGO_MAX_WIDTH_DEFAULT_COMPACT : LOGO_MAX_WIDTH_DEFAULT,
  };

  if (aspect === "wide") {
    imageStyle.maxWidth = isCompact ? LOGO_MAX_WIDTH_WIDE_COMPACT : LOGO_MAX_WIDTH_WIDE;
  }

  if (aspect === "tall") {
    imageStyle.maxHeight = isCompact ? "3rem" : "4rem";
    imageStyle.maxWidth = isCompact ? "3rem" : "4rem";
  }

  return (
    <div style={containerStyle}>
      <img src={src} alt="Logo" style={imageStyle} loading="lazy" />
      {showStatusDot && (
        <span
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: isCompact ? STATUS_DOT_SIZE_COMPACT : STATUS_DOT_SIZE,
            height: isCompact ? STATUS_DOT_SIZE_COMPACT : STATUS_DOT_SIZE,
            borderRadius: "9999px",
            backgroundColor: statusColor,
            border: `${isCompact ? STATUS_DOT_BORDER_WIDTH_COMPACT : STATUS_DOT_BORDER_WIDTH} solid #ffffff`,
            transform: `translate(${
              isCompact ? STATUS_DOT_OFFSET_COMPACT : STATUS_DOT_OFFSET
            }, ${isCompact ? STATUS_DOT_OFFSET_COMPACT : STATUS_DOT_OFFSET})`,
            pointerEvents: "none",
          }}
        />
      )}
    </div>
  );
};

export default LogoImage;

